import { render } from "./VueScroll.vue?vue&type=template&id=79482aa0&scoped=true"
import script from "./VueScroll.vue?vue&type=script&lang=js"
export * from "./VueScroll.vue?vue&type=script&lang=js"

import "./VueScroll.vue?vue&type=style&index=0&id=79482aa0&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79482aa0"]])

export default __exports__